import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { adminLogin } from "../lib/api";
import { useToast } from "../hooks/use-toast";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(form.username, form.password);
      localStorage.setItem("dm_admin_token", token);
      toast({ title: "Welcome back, DaMarkas" });
      navigate("/admin");
    } catch (err) {
      toast({
        title: "Login failed",
        description: err?.response?.data?.detail || "Check username & password",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center p-5 field-lines">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md border border-neutral-800 bg-neutral-900/70 rounded-sm p-8 backdrop-blur"
      >
        <div className="flex items-center gap-3 mb-8">
          <span className="flex items-center justify-center w-11 h-11 rounded-sm bg-red-600 text-white">
            <Shield className="w-5 h-5" />
          </span>
          <div>
            <div className="font-display text-xl tracking-wider text-white">ADMIN LOGIN</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-heading">
              DaMarkas McNeese Portfolio
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="u" className="text-xs uppercase tracking-[0.25em] font-heading text-neutral-300">
              Username
            </Label>
            <Input
              id="u"
              autoComplete="username"
              value={form.username}
              onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))}
              className="bg-neutral-950 border-neutral-800 text-white h-11 rounded-sm focus-visible:ring-red-600"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="p" className="text-xs uppercase tracking-[0.25em] font-heading text-neutral-300">
              Password
            </Label>
            <Input
              id="p"
              type="password"
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              className="bg-neutral-950 border-neutral-800 text-white h-11 rounded-sm focus-visible:ring-red-600"
            />
          </div>
        </div>

        <Button
          type="submit"
          disabled={loading}
          className="btn-primary mt-8 w-full bg-red-600 hover:bg-red-700 text-white font-heading uppercase tracking-widest rounded-sm h-11"
        >
          {loading ? "Signing in..." : (<><Lock className="w-4 h-4 mr-2" /> Sign In</>)}
        </Button>

        <div className="mt-6 text-center">
          <a href="/" className="text-xs uppercase tracking-[0.25em] text-neutral-500 hover:text-red-500 font-heading">
            ← Back to Site
          </a>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
